import { useCallback } from "react";
import {
  Checkbox,
  Chip,
  Link,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import {
  CheckCircle,
  FileDownloadOutlined,
  RotateLeft,
} from "@mui/icons-material";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";
import { SELECTED_ROW_CLASS } from "src/Pages/Company/Pending/PendingBenefits/const";
import { IWaitingRoomsGroup } from "src/Pages/Company/Pending/PendingBenefits/types";

import __ from "src/utils/Translations";

import { AcceptSalaryDeduction } from "./AcceptSalaryDeduction";
import { SalaryDeductionDocument } from "./SalaryDeductionDocument";

export const SalaryDeductionRow = ({
  waitingRoomsGroup,
}: {
  waitingRoomsGroup: IWaitingRoomsGroup;
}) => {
  const { isSalaryDeductionSelected, selectSalaryDeduction } =
    useSelectedRows();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      selectSalaryDeduction(waitingRoomsGroup)(event.target.checked),
    [selectSalaryDeduction, waitingRoomsGroup]
  );

  return (
    <TableRow
      className={
        isSalaryDeductionSelected(waitingRoomsGroup) ? SELECTED_ROW_CLASS : ""
      }
    >
      <TableCell padding="checkbox" sx={{ paddingLeft: "24px" }}>
        <Checkbox
          color="primary"
          checked={isSalaryDeductionSelected(waitingRoomsGroup)}
          onChange={handleChange}
        />
      </TableCell>
      <TableCell colSpan={4}>{__("Zgoda na potrącenie")}</TableCell>
      <TableCell>
        <Stack sx={{ gap: 1, alignItems: "start" }}>
          {!waitingRoomsGroup.documentActive ? (
            <SalaryDeductionDocument groupId={waitingRoomsGroup.groupId} />
          ) : (
            waitingRoomsGroup.salaryDeductionAccepted && (
              <Chip
                icon={<CheckCircle aria-hidden="true" />}
                label={__("Zaakceptowana zgoda na potrącenie")}
                color="success"
                size="small"
                variant="outlined"
                sx={{
                  bgcolor: "green.50",
                }}
              />
            )
          )}
        </Stack>
      </TableCell>
      <TableCell sx={{ paddingRight: "24px" }}>
        {waitingRoomsGroup.documentActive && (
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Stack>
              <Typography variant="subtitle2" component="div">
                {__("Dokument")}
              </Typography>
              {waitingRoomsGroup.documentUrl?.pl && (
                <Link
                  href={waitingRoomsGroup.documentUrl.pl}
                  download
                  color="textPrimary"
                  noWrap
                  variant="body1"
                >
                  PL {__("Potrącenie z wynagrodzenia")}
                  <FileDownloadOutlined color="inherit" aria-hidden="true" />
                </Link>
              )}
              {waitingRoomsGroup.documentUrl?.en && (
                <Link
                  href={waitingRoomsGroup.documentUrl.en}
                  download
                  color="textPrimary"
                  noWrap
                  variant="body1"
                >
                  EN {__("Potrącenie z wynagrodzenia")}
                  <FileDownloadOutlined color="inherit" aria-hidden="true" />
                </Link>
              )}
            </Stack>
            {!waitingRoomsGroup.salaryDeductionAccepted && (
              <AcceptSalaryDeduction waitingRoomsGroup={waitingRoomsGroup} />
            )}
          </Stack>
        )}
      </TableCell>
    </TableRow>
  );
};
